/**
 * Removes HTML tags and stray angle brackets from a string.
 * Useful for rendering API-provided text safely in plain text contexts.
 */
export const stripHtmlTags = (text: string) =>
	text
		.replace(/<[^>]*>/g, '') // remove well-formed tags
		.replace(/[<>]/g, ''); // remove stray angle brackets

